import * as React from 'react';

export default function SupportLight(props) {
  const { width = 150, height = 150, primary } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
      <defs>
        <clipPath id="a">
          <path
            data-name="Rectangle 3508"
            fill="#fff"
            stroke="#707070"
            d="M0 0h35v35H0z"
          />
        </clipPath>
        <clipPath id="b">
          <path data-name="Rectangle 3511" d="M0 0h35v35H0z" />
        </clipPath>
      </defs>
      <g clipPath="url(#a)">
        <g clipPath="url(#b)" data-name="Mask Group 1664">
          <path
            data-name="Subtraction 22"
            d="M26.071 21.982a9.337 9.337 0 0 0 2.608-2.489 9.866 9.866 0 0 0 1.525-3.463c.089-.381 1.019-.945 2-1.542 1.14-.686 2.309-1.394 2.3-1.887-.01-.591-1.167-1.228-2.286-1.844-.486-.267-.988-.544-1.375-.807a1.818 1.818 0 0 1-.751-.765 10.2 10.2 0 0 0-3.84-5.2 10.676 10.676 0 0 0-2.953-1.456 11.316 11.316 0 0 0-3.4-.515h-.207a10.628 10.628 0 0 0-4.156.917 10.739 10.739 0 0 0-1.8 1.023 10.848 10.848 0 0 0-4.61 9.006 10.988 10.988 0 0 1 6.174-1.849h.207a10.628 10.628 0 0 1 4.138.91 10.738 10.738 0 0 1 1.8 1.015 10.85 10.85 0 0 1 1.559 1.338 10.9 10.9 0 0 1 1.286 1.6 10.871 10.871 0 0 1 .968 1.831 10.829 10.829 0 0 1 .813 4.177Z"
            fill="#fff"
          />
          <path
            d="M26.071 21.982a9.337 9.337 0 0 0 2.608-2.489 9.866 9.866 0 0 0 1.525-3.463c.089-.381 1.019-.945 2-1.542 1.14-.686 2.309-1.394 2.3-1.887-.01-.591-1.167-1.228-2.286-1.844-.486-.267-.988-.544-1.375-.807a1.818 1.818 0 0 1-.751-.765 10.2 10.2 0 0 0-3.84-5.2 10.676 10.676 0 0 0-2.953-1.456 11.316 11.316 0 0 0-3.4-.515h-.207a10.628 10.628 0 0 0-4.156.917 10.739 10.739 0 0 0-1.8 1.023 10.848 10.848 0 0 0-4.61 9.006 10.988 10.988 0 0 1 6.174-1.849h.207a10.628 10.628 0 0 1 4.138.91 10.738 10.738 0 0 1 1.8 1.015 10.85 10.85 0 0 1 1.559 1.338 10.9 10.9 0 0 1 1.286 1.6 10.871 10.871 0 0 1 .968 1.831 10.829 10.829 0 0 1 .813 4.177Z"
            fill={primary}
            opacity={0.35}
          />
          <g data-name="Path 62588">
            <path
              data-name="Path 63100"
              d="M26.074 22.147A10.8 10.8 0 0 1 15.13 32.802c-5.028-.085-9.035-2.907-10.146-7.66-.19-.82-4.313-2.506-4.297-3.428C.706 20.6 4.76 19.34 5.1 18.294a10.543 10.543 0 0 1 10.397-7.17 10.8 10.8 0 0 1 10.576 11.023Z"
              fill="none"
            />
            <path
              data-name="Path 63101"
              d="M24.674 22.122a9.412 9.412 0 0 0-9.2-9.598 9.177 9.177 0 0 0-9.042 6.205c-.33 1.016-1.467 1.642-2.783 2.368-.303.166-.717.394-1.064.608.364.242.8.505 1.119.699 1.457.883 2.42 1.465 2.644 2.42.932 3.981 4.304 6.502 8.805 6.579a9.412 9.412 0 0 0 9.521-9.28m1.4.023A10.8 10.8 0 0 1 15.13 32.802c-5.028-.085-9.035-2.907-10.146-7.66-.19-.82-4.313-2.506-4.297-3.428C.706 20.6 4.76 19.34 5.1 18.296a10.542 10.542 0 0 1 10.397-7.171 10.8 10.8 0 0 1 10.576 11.02Z"
              fill="#fff"
            />
          </g>
          <path
            data-name="Path 62586"
            d="M11.78 20.364h1.914a1.318 1.318 0 0 1 .41-.928 1.389 1.389 0 0 1 .982-.346 1.6 1.6 0 0 1 .706.147 1.15 1.15 0 0 1 .47.4 1.023 1.023 0 0 1 .166.579 1.405 1.405 0 0 1-.106.565 1.3 1.3 0 0 1-.364.463 5.063 5.063 0 0 1-.717.486 3.388 3.388 0 0 0-.78.589 1.726 1.726 0 0 0-.415.717 2.645 2.645 0 0 0-.074.942l.014.4h1.869v-.363a1.468 1.468 0 0 1 .106-.582 1.307 1.307 0 0 1 .368-.469 4.609 4.609 0 0 1 .727-.483 3.312 3.312 0 0 0 1.13-.983 2.317 2.317 0 0 0 .381-1.34 2.345 2.345 0 0 0-.42-1.381 2.771 2.771 0 0 0-1.172-.941 4.291 4.291 0 0 0-1.762-.336 4.226 4.226 0 0 0-1.844.367 2.723 2.723 0 0 0-1.165 1.009 2.887 2.887 0 0 0-.424 1.487Zm3.214 7.311a1.347 1.347 0 0 0 .936-.308 1.068 1.068 0 0 0 .342-.836 1.074 1.074 0 0 0-.342-.846 1.357 1.357 0 0 0-.936-.3 1.371 1.371 0 0 0-.939.3 1.069 1.069 0 0 0-.346.846 1.063 1.063 0 0 0 .346.836 1.361 1.361 0 0 0 .939.308Z"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
}
